import React from 'react';

import Wrapper from './Wrapper';
import SocialLink from './SocialLink';

function Social({ website, twitter, github, linkedin, brave, bittube}) {
  return (
    <Wrapper>
      {website && (
        <SocialLink href={website} target="_self" rel="noopener">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          Email
        </SocialLink>
      )}
      {twitter && (
        <SocialLink href={twitter} target="_blank" rel="noopener">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
          </svg>
          Twitter
        </SocialLink>
      )}
      {github && (
        <SocialLink href={github} target="_blank" rel="noopener">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
          </svg>
          Github
        </SocialLink>
      )}
      {linkedin && (
        <SocialLink href={linkedin} target="_blank" rel="noopener">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
            <rect x="2" y="9" width="4" height="12" />
            <circle cx="4" cy="4" r="2" />
          </svg>
          LinkedIn
        </SocialLink>
      )}
      {brave && (
        <SocialLink href={brave} target="_blank" rel="noopener">
            <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 300 300"
            fill="none"
            stroke="black"
            strokeWidth="15"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
          <path d="m209.98 61.285l5.984-14.706s-7.616-8.1702-16.864-17.43c-9.248-9.2596-28.832-3.8128-28.832-3.8128l-22.304-25.336h-39.168-39.168l-22.304 25.336s-19.584-5.4468-28.832 3.8128c-9.248 9.2596-16.864 17.43-16.864 17.43l5.984 14.706-7.616 21.787s22.399 84.946 25.024 95.319c5.168 20.426 8.704 28.323 23.392 38.672s41.344 28.323 45.696 31.047 9.792 7.3625 14.688 7.3625 10.336-4.639 14.688-7.3625 31.008-20.698 45.696-31.047 18.224-18.247 23.392-38.672c2.6243-10.373 25.024-95.319 25.024-95.319l-7.616-21.787z"/>
          <path d="m164.02 41.404s28.688 34.723 28.688 42.145-3.6089 9.3799-7.2374 13.238c-3.6285 3.858-19.476 20.707-21.511 22.871-2.0351 2.164-6.2718 5.4446-3.7797 11.35s6.1684 13.419 2.0803 21.04c-4.0887 7.6212-11.093 12.708-15.581 11.867-4.488-0.84153-15.028-6.3564-18.904-8.8756s-16.161-12.663-16.161-16.545c0-3.8809 12.699-10.849 15.044-12.433 2.3468-1.5828 13.047-7.711 13.267-10.116 0.21869-2.4059 0.13546-3.1112-3.0225-9.0548-3.1579-5.9441-8.8449-13.876-7.8983-19.153 0.94656-5.2769 10.118-8.021 16.664-10.496 6.5443-2.4745 19.146-7.1484 20.72-7.875 1.5749-0.72715 1.168-1.4194-3.6013-1.8721-4.7682-0.45263-18.301-2.2512-24.402-0.54849-6.101 1.7027-16.524 4.2932-17.368 5.6669s-1.589 1.42-0.72189 6.1587c0.86659 4.7387 5.3307 27.477 5.7637 31.516 0.43357 4.0388 1.2811 6.7088-3.0682 7.7045-4.3498 0.99568-11.672 2.7245-14.188 2.7245s-9.8382-1.7288-14.188-2.7245c-4.3498-0.99568-3.5023-3.6657-3.0687-7.7045 0.43357-4.0388 4.8971-26.777 5.7642-31.516 0.86659-4.7387 0.12186-4.785-0.72189-6.1587-0.84429-1.3737-11.268-3.9642-17.369-5.6669-6.101-1.7027-19.633 0.095864-24.402 0.54849s-5.1756 1.1449-3.6013 1.8721c1.5743 0.7266 14.176 5.4005 20.72 7.875 6.5449 2.475 15.717 5.2191 16.664 10.496 0.94656 5.2774-4.741 13.209-7.8983 19.153-3.1579 5.9436-3.2417 6.6489-3.0225 9.0548 0.21869 2.4053 10.92 8.5335 13.266 10.116 2.3463 1.5834 15.044 8.552 15.044 12.433 0 3.8814-12.284 14.026-16.16 16.545s-14.416 8.034-18.904 8.8756c-4.488 0.84099-11.492-4.2458-15.581-11.867-4.0882-7.6212-0.41181-15.135 2.0797-21.04 2.4921-5.9049-1.7441-9.1855-3.7797-11.35-2.0346-2.1635-17.882-19.013-21.511-22.871-3.6285-3.858-7.2368-5.8166-7.2368-13.238s28.688-42.145 28.688-42.145 24.208 4.6298 27.472 4.6298 10.336-2.7234 16.864-4.9021c6.528-2.1787 10.88-2.1945 10.88-2.1945s4.352 0.015796 10.88 2.1945 13.6 4.9021 16.864 4.9021 27.472-4.6298 27.472-4.6298zm-21.507 132.82c1.7756 1.1133 0.69251 3.212-0.9248 4.3569-1.6179 1.1449-23.357 18-25.466 19.862-2.1102 1.8634-5.2104 4.9403-7.3184 4.9403s-5.2088-3.0769-7.3184-4.9403c-2.1102-1.8628-23.848-18.717-25.466-19.862-1.6179-1.1449-2.7004-3.2436-0.9248-4.3569 1.7762-1.1128 7.332-3.9217 14.999-7.8941 7.6655-3.9718 17.22-7.3488 18.711-7.3488s11.045 3.377 18.711 7.3488c7.666 3.9724 13.222 6.7813 14.998 7.8941z"/>
          </svg>
          Brave
        </SocialLink>
      )}
      {bittube && (
        <SocialLink href={bittube} target="_blank" rel="noopener">
             <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 300 300"
            fill="none"
            stroke="black"
            strokeWidth="15"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
		      <path class="st0" d="m248.8 52.6c-24.4-49.6-96.5-63.8-161-31.7-64.6 32.2-97.1 98.5-72.7 148.2s96.5 63.9 161.1 31.7 97.1-98.5 72.6-148.2zm-76.2 138.8c-46.9 23.3-102.5 6.3-124.4-38.1-21.8-44.4-1.5-99.3 45.4-122.7 46.9-23.3 102.5-6.3 124.4 38.1 21.7 44.5 1.4 99.4-45.4 122.7zm11-83.6l-81.9-50c-2.5-1.3-5.5 0.4-5.5 3.3v99.7c0 2.8 3 4.6 5.5 3.3l81.9-49.7c2.6-1.5 2.6-5.2 0-6.6z"/>
          </svg>
          BitTube
        </SocialLink>
      )}
    </Wrapper>
  );
}

export default Social;
